import { useEffect } from "react";
import { apiGet, endSession } from "../../Api/Client.js";

const SIGNED_IN_KEY = "intranet.signedIn";
const BACK_TO_TAB_MS = 300;

// Keeps a signed-in tab honest about its session. Each guard ends the session the same way (endSession) and only
// while someone is signed in and not on the sign-in page.
//  1. any request answered 401 (the client announces it as "auth:unauthorized"), or a 401 inside the bulk load
//  2. the person comes back to the tab: ask the server who they are, in case the session was deleted meanwhile
//  3. sign-out in another tab: the signed-in mark disappears from storage
export function useSessionGuards({ hasAuth, isLoginRoute, errors }) {
  const active = hasAuth && !isLoginRoute;

  useEffect(() => {
    if (!active) return undefined;
    const end = () => endSession();
    window.addEventListener("auth:unauthorized", end);
    return () => window.removeEventListener("auth:unauthorized", end);
  }, [active]);

  useEffect(() => {
    if (active && errors.some((e) => e.status === 401)) endSession();
  }, [errors, active]);

  useEffect(() => {
    if (!active) return undefined;
    let timer = null;
    const onVisible = () => {
      if (document.visibilityState !== "visible") return;
      clearTimeout(timer);
      // Debounced so a tab that flashes visible does not ask. A 401 fires "auth:unauthorized" from the client.
      timer = setTimeout(() => { apiGet("/Users/Auth/Me/").catch(() => {}); }, BACK_TO_TAB_MS);
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => { document.removeEventListener("visibilitychange", onVisible); clearTimeout(timer); };
  }, [active]);

  useEffect(() => {
    if (!hasAuth) return undefined;
    const onStorage = (event) => { if (event.key === SIGNED_IN_KEY && !event.newValue) endSession(); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [hasAuth]);
}
